import React from 'react';
import Label from 'shared/components/Label';
import SelectComponent from 'shared/components/SelectComponent';

const railWidthOptions = [
  {
    value: '',
    text: 'Select One',
  },
  {
    value: '0.250',
    text: '0.250"',
  },
  {
    value: '0.400',
    text: '0.400"',
  },
  {
    value: '0.500',
    text: '0.500"',
  },
];

const RailWidth = (props) => {
  const {
    parameters,
    name,
    onChangeParameter,
    inputId,
    groupName,
    options,
  } = props;

  const currentValue = parameters[name];

  return (
    <SelectComponent
      name={name}
      selected={currentValue}
      onChange={(e) => onChangeParameter(name, e.target.value)}
      inputId={inputId}
      groupName={groupName}
      options={options}
      parameters={parameters} />
  );
};

RailWidth.defaultProps = {
  name: 'rail_width',
  groupName: 'parameters',
  options: railWidthOptions,
};

const ArrayRailsWidth = (props) => {
  const {
    parameters,
    onChangeParameter,
    groupName,
  } = props;

  return (
    <div className="form-group">
      <Label label="Rail Width" />
      <RailWidth
        onChangeParameter={onChangeParameter}
        inputId="rail-width"
        groupName={groupName}
        parameters={parameters} />
      <div className="error-place" />
    </div>
  );
};

export default ArrayRailsWidth;
